import { Calendar } from "primereact/calendar";
import { useEffect, useRef, useState } from "react";
import { checkLastMonth, checkLastWeek, checkLastYear, checkThisMonth, checkThisWeek, checkThisYear, checkToday, checkYesterday, convertDate, formatDate } from "../../../../../../../features/dataFormatFunctions/dataFormatter";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../../../stateManagement/hooks/redux";
import { setCustomMapAppliedFilters, setCustomMapFiltersState } from "../../../../../../../stateManagement/reducers/custom/CustomMapSlice";
import { Button } from "primereact/button";
import { setLastMonthDateFilterRange as getDateFilterLastMonthRangeValues, setLastWeekDateFilterRange as getDateFilterLastWeekRangeValues, setLastYearDateFilterRange as getDateFilterLastYearRangeValues, setThisMonthDateFilterRange as getDateFilterThisMonthRangeValues, setThisWeekDateFilterRange as getDateFilterThisWeekRangeValues, setThisYearDateFilterRange as getDateFilterThisYearRangeValues, getTodayDateFilterRange as getDateFilterTodayRangeValues, setYesterdayDateFilterRange as getDateFilterYesterdayRangeValues } from "./customFilterCalendarFunctions";
import { Checkbox } from "primereact/checkbox";
import { setItemWebStorage } from "../../../../../../../features/webStorageSaver";

function formatFilterCalendarRangeValues(minValue: any, maxValue: any): any {
    if (minValue) {
        let minDateValue = minValue ? new Date(minValue) : null
        let maxDateValue = maxValue ? new Date(maxValue) : null
        return [minDateValue, maxDateValue]
    }
    return null
}

function formatFilterCalendarSingleValue(value: any): any {
    if (value) {
        const dateValue = value ? new Date(value) : null
        return dateValue
    }
    return null
}

const presetRangeValuesButtonsOptions: any = {
    "today": {
        filterRangeValues: getDateFilterTodayRangeValues(),
        activeStyleFunction: (rangeDates: any) => checkToday(rangeDates)
    },
    "yesterday": {
        filterRangeValues: getDateFilterYesterdayRangeValues(),
        activeStyleFunction: (rangeDates: any) => checkYesterday(rangeDates)
    },
    "this-week": {
        filterRangeValues: getDateFilterThisWeekRangeValues(),
        activeStyleFunction: (rangeDates: any) => checkThisWeek(rangeDates)
    },
    "last-week": {
        filterRangeValues: getDateFilterLastWeekRangeValues(),
        activeStyleFunction: (rangeDates: any) => checkLastWeek(rangeDates)
    },
    "this-month": {
        filterRangeValues: getDateFilterThisMonthRangeValues(),
        activeStyleFunction: (rangeDates: any) => checkThisMonth(rangeDates)
    },
    "last-month": {
        filterRangeValues: getDateFilterLastMonthRangeValues(),
        activeStyleFunction: (rangeDates: any) => checkLastMonth(rangeDates)
    },
    "this-year": {
        filterRangeValues: getDateFilterThisYearRangeValues(),
        activeStyleFunction: (rangeDates: any) => checkThisYear(rangeDates)
    },
    "last-year": {
        filterRangeValues: getDateFilterLastYearRangeValues(),
        activeStyleFunction: (rangeDates: any) => checkLastYear(rangeDates)
    }
}

export default function CustomFilterCalendar({ fieldName, objectTypeName }: any) {
    const dispatch = useDispatch()
    const filtersState = useAppSelector(state => state.customMap.customMapFiltersState)
    const appliedFilters = useAppSelector(state => state.customMap.customMapAppliedFilters)
    const { minValue, maxValue, value, filterType, presetValues, ignoreFilterValue } = filtersState[fieldName]
    const [dateTextValue, setDateTextValue] = useState('Выберите начальную дату')

    function applyFilterCalendarIgnoreValue(checked: boolean, fieldName: string) {
        let newFiltersState = structuredClone(filtersState)
        let appliedFilter
        newFiltersState[fieldName].ignoreFilterValue.checked = checked
        appliedFilter = { [`ignore-${fieldName}`]: checked }
        dispatch(setCustomMapFiltersState(newFiltersState))
        setItemWebStorage(`customMapFiltersState-${objectTypeName}`, newFiltersState)
        let newAppliedFilters = {
            ...appliedFilters,
            [fieldName]: {
                ...appliedFilters[fieldName],
                ...appliedFilter
            }
        }
        dispatch(setCustomMapAppliedFilters(newAppliedFilters))
        setItemWebStorage(`customMapAppliedFilters-${objectTypeName}`, newAppliedFilters)
    }

    function setFilterCalendarRangeValues(value: any) {
        const [minDateValue, maxDateValue] = value.map((value: any) => convertDate(value))
        let newFiltersState = structuredClone(filtersState)
        newFiltersState[fieldName].minValue = minDateValue
        newFiltersState[fieldName].maxValue = maxDateValue
        if (minDateValue && maxDateValue) {
            newFiltersState[fieldName].ignoreFilterValue.checked = false
        }
        dispatch(setCustomMapFiltersState(newFiltersState))
        setItemWebStorage(`customMapFiltersState-${objectTypeName}`, newFiltersState)
        if (minDateValue && maxDateValue) {
            let newAppliedFilters = {
                ...appliedFilters,
                [fieldName]: {
                    ...appliedFilters[fieldName],
                    minValue: minDateValue,
                    maxValue: maxDateValue,
                    [`ignore-${fieldName}`]: false
                }
            }
            dispatch(setCustomMapAppliedFilters(newAppliedFilters))
            setItemWebStorage(`customMapAppliedFilters-${objectTypeName}`, newAppliedFilters)
        }
    }

    function setFilterCalendarSingleValue(value: any) {
        const dateValue = convertDate(value)
        let newFiltersState = structuredClone(filtersState)
        newFiltersState[fieldName].value = dateValue
        if (dateValue) {
            newFiltersState[fieldName].ignoreFilterValue.checked = false
        }
        dispatch(setCustomMapFiltersState(newFiltersState))
        setItemWebStorage(`customMapFiltersState-${objectTypeName}`, newFiltersState)
        if (dateValue) {
            let newAppliedFilters = {
                ...appliedFilters,
                [fieldName]: {
                    ...appliedFilters[fieldName],
                    value: dateValue,
                    [`ignore-${fieldName}`]: false
                }
            }
            dispatch(setCustomMapAppliedFilters(newAppliedFilters))
            setItemWebStorage(`customMapAppliedFilters-${objectTypeName}`, newAppliedFilters)
        }
    }

    useEffect(() => {
        if (minValue && maxValue) {
            if (minValue === maxValue) {
                setDateTextValue(`${formatDate(minValue)}`)
            }
            else {
                setDateTextValue(`${formatDate(minValue)} - ${formatDate(maxValue)}`)
            }
        }
        else {
            if (!minValue && !maxValue) {
                setDateTextValue("Выберите начальную дату")
            }
            if (minValue && !maxValue) {
                setDateTextValue("Выберите конечную дату")
            }
        }
    }, [minValue, maxValue])

    return (
        <div className="filter-calendar">
            <div className="map-hint-filters-checkbox-div">
                <Checkbox
                    inputId={`ignore-${fieldName}`}
                    name={`ignore-${fieldName}`}
                    onChange={(event: any) => applyFilterCalendarIgnoreValue(event.checked, fieldName)}
                    checked={ignoreFilterValue?.checked}
                />
                <label htmlFor={`ignore-${fieldName}`} className="ms-2">{ignoreFilterValue.caption}</label>
            </div>
            <div className={"calendar" + (ignoreFilterValue?.checked ? " filter-ignore" : '')}>
                {filterType === "between" &&
                    <>
                        <Calendar
                            value={formatFilterCalendarRangeValues(minValue, maxValue)}
                            onChange={(event: any) => setFilterCalendarRangeValues(event.value)}
                            inline
                            selectOtherMonths
                            selectionMode="range"
                            maxDate={new Date()}
                        />
                        <div className="show-date-filter-div">
                            <div className="date-filter-text">{dateTextValue}</div>
                        </div>
                    </>
                }
                {filterType === "from" &&
                    <>
                        <Calendar
                            value={formatFilterCalendarSingleValue(value)}
                            onChange={(event: any) => setFilterCalendarSingleValue(event.value)}
                            inline
                            selectOtherMonths
                            selectionMode="single"
                            maxDate={new Date()}
                        />
                    </>
                }
            </div>
            {presetValues &&
                <div className={"preset-values-buttons-div" + (ignoreFilterValue?.checked ? " filter-ignore" : '')}>
                    {filterType === "between" &&
                        <>
                            {presetValues.map((presetValue: any) => {
                                const { filterRangeValues, activeStyleFunction } = presetRangeValuesButtonsOptions[presetValue?.type]
                                return (
                                    <Button
                                        className="preset-values-button"
                                        onClick={() => setFilterCalendarRangeValues(filterRangeValues)}
                                        outlined={!activeStyleFunction([minValue, maxValue])}
                                    >
                                        {presetValue?.caption}
                                    </Button>
                                )
                            })}
                        </>
                    }
                </div>
            }
        </div>
    )
}
